<div class="circle-wrap" [ngClass]="{'mob': isMobile}">
  <div class="circle">
    <div class="mask full">
      <div class="fill"></div>
    </div>
    <div class="mask half">
      <div class="fill"></div>
    </div>
    <div class="inside-circle">
      <ng-container *ngIf="showPercentage">{{ targetPercentage }}%</ng-container>
    </div>
  </div>
</div>